export default __webpack_public_path__ + "static/media/sdg-14-load.d5632aa1.png";